import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import {UploadImage} from 'components/UI/Image';
import { ShowIf } from 'components/utils';

class BusinessForwardedItem extends Component {

  static propTypes = {
    data: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired
  }

  render() {
    const { data, index } = this.props;
    if (!data) {
      return null;
    }

    let Img = null;
    if (this.props.data.logo) {
      Img = <UploadImage width={80} height={80} type='BUSINESS' image={this.props.data.logo} transform='crop'/>
    } else {
      Img = <img src={require('assets/images/placeholder-128.jpg')} alt="..." width="100" height="100"/>;
    }

    return (
      <tr className="tr">
        <td className="td col-lg-1">
          {index}
        </td>
        <td className="td col-lg-10">
        <div className="business-info">
          <div className="box-image">
            {Img}
          </div>
          <div className="box-content">
            <p className="box-text">
              <span className="text">{data.name}</span>
            </p>
            <p className="box-text">
              <span className="title">SĐT:&nbsp;</span>
              <span className="text">{data.phone}</span>
            </p>
            <p className="box-text">
              <span className="title">Email:&nbsp;</span>
              <span className="text">{data.email}</span>
            </p>
          </div>
        </div>
        </td>
        <td className="td col-lg-2 text-center">
          <ShowIf condition={data.actionTakenOn}>
            <span className="label label-success label-medium">Đã tương tác</span>
          </ShowIf>
          <ShowIf condition={!data.actionTakenOn}>
            <span className="label label-primary label-medium">Chưa tương tác</span>
          </ShowIf>
        </td>
      </tr>
    );
  }
}

export default BusinessForwardedItem;


// WEBPACK FOOTER //
// ./components/business/BusinessForwardedItem.jsx